// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--ps7BE","image":"_103a151b99--image--XYuUS","text":"_103a151b99--text--JWjJx"};